import { render, staticRenderFns } from "./ModalRecommendMob.vue?vue&type=template&id=2c0debca&scoped=true&"
import script from "./ModalRecommendMob.vue?vue&type=script&lang=js&"
export * from "./ModalRecommendMob.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecommendMob.vue?vue&type=style&index=0&id=2c0debca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0debca",
  null
  
)

export default component.exports